import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FurService } from 'src/app/services/fur.service';
import { Fur } from 'src/app/models/Fur';
import { DenunciaContenedorComponent } from '../denuncia/denuncia-contenedor/denuncia-contenedor.component';
import { MatDialog } from '@angular/material/dialog';
import { Persona } from 'src/app/models/Persona';
import { ContenedorDenuncianteComponent } from '../Denunciante/Contenedor/contenedor-denunciante.component';
import { ContenedorMpComponent } from '../MedidasProt/contenedor-mp/contenedor-mp.component';
import { DatosGeneralComponent } from '../datos-general/datos-general.component';
import { DatosGeneral } from 'src/app/models/personalizados/DatosGeneral';
import { MformularioWebC } from 'src/app/models/personalizados/MformularioWebC';
import { MdenunciaContenedorC } from 'src/app/models/personalizados/MdenunciaContenedorC';
import { MentidadHechoC } from 'src/app/models/personalizados/mEntidadHechoC';
import { ContenedorWebComponent } from './contenedor-web/contenedor-web.component';
import {
  cambiarRouter,
  cookieGlobalVars,
  DscDenuncAnonimo,
  DscMensajeSpinner2,
  DscPathFwExt,
  GlobalVars, loadCaptcha01,
  ngClassSalirModal,
  NumIdEstadoBorrador, openModalMensaje,
  openModalMensajePrg, servicioToken,
  uuid
} from 'src/app/general/variables';
import { General } from 'src/app/models/General';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { FrmUtilSADEncode } from 'src/app/models/util/FrmUtilSADEncode';
import { UtilService } from 'src/app/services/util/util.service';
import { EntidadService } from 'src/app/services/entidad/entidad.service';
@Component({
  selector: 'app-formulario-web',
  templateUrl: './formulario-web.component.html',
  styleUrls: ['./formulario-web.component.css']
})
export class FormularioWebComponent implements OnInit {

  @Output() salirOut = new EventEmitter();

  @ViewChild(DenunciaContenedorComponent) denunciaContenedorC: DenunciaContenedorComponent;
  @ViewChild(ContenedorDenuncianteComponent) contenedorDenuncianteC: ContenedorDenuncianteComponent;
  @ViewChild(ContenedorMpComponent) contenedorMpC: ContenedorMpComponent;
  @ViewChild(DatosGeneralComponent) datosGeneralC: DatosGeneralComponent;
  @ViewChild(ContenedorWebComponent) contenedorWerb: ContenedorWebComponent;

  flgViewBtn = true;
  flgViewBtnInfCompl = false;
  flgDeshBtnInfoCompl = true;
  flgGuardarDefinitivo = false;
  tabDenunciante = false;
  tabProteccion = false;
  furFw: Fur = null;
  persona: Persona;
  flgDeshabilitaGuardar = false;
  flgGuardado = false;
  flgViewCW = true;
  flgEnviarDenuncia = false;
  flgGuardarBorrador = false;
  flgNewFw = true;
  flgAccionGB = false;
  flgDeshabilitarSalir = false;
  strDscDenunciante = DscDenuncAnonimo;
  ngClassSalirModal = ngClassSalirModal;
  strDscTitulo = 'Formulario Virtual';
  strDscMensajeSpinner: string = DscMensajeSpinner2;
  frmUtilSADEncode: FrmUtilSADEncode;
  generalParams: General;

  mFormularioWebC: MformularioWebC;
  constructor(protected furService: FurService,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService,
              protected utilService: UtilService,
              public router: Router,
              protected entidadService: EntidadService) {


    }


  ngOnInit() {
    this.loadCaptcha();
    this.flgViewCW = true;

    setTimeout(() => {

      this.contenedorWerb.mostrarDatosGen(false);

    }, 0);

    cookieGlobalVars(4);

    const boolFlgNuevoFw: boolean = GlobalVars.FlgNuevoFw;
    const fur: Fur = GlobalVars.objetoFurAcceda;

    if (boolFlgNuevoFw == false) {


    }

    const url: string = this.router.url;
    const posFW: number = url.indexOf(DscPathFwExt);
    let posPath = 0;
    let idInstancia = '';


    if (posFW > 0) {

      posPath = url.lastIndexOf('/');

      idInstancia = url.substring(posPath + 1);

      this.frmUtilSADEncode = new FrmUtilSADEncode();
      this.frmUtilSADEncode.flagEncodDecod = 2;
      this.frmUtilSADEncode.textoEntrada = idInstancia;

      console.log('this.frmUtilSADEncode', this.frmUtilSADEncode);

      this.utilService.encode(this.frmUtilSADEncode).subscribe(data => {

        // this._denuncia(3);

        setTimeout(() => {

          this.generalParams = new General();

          this.generalParams.flgCampo1 = true;
          this.generalParams.numCampo1 = Number(data.resultado);

          console.log('======this.generalParams', this.generalParams);

          console.log('======this.generalParams1');

          this.setGeneralParams(this.generalParams);

        }, 0);

      });
    }
    /////

  }

  _salirFormulario() {

    cambiarRouter(this.router, 1);

  }

  _salir() {

    openModalMensajePrg(this.strDscTitulo, '¿Está seguro que desea salir del registro del Formulario Virtual?', this.dialog).subscribe(result => {

      if (result == false ) {

        // this.salirOut.emit();
        cambiarRouter(this.router, 1);

      }


    });

  }


  _viewBtnTrx(numCaso: number) {

    switch (numCaso) {
      case 1:

        this.flgViewBtn = true;
        this.flgViewBtnInfCompl = false;

        break;

      case 2:

        this.flgViewBtn = false;
        this.flgViewBtnInfCompl = true;

        break;

      default:
        break;
    }

    this._deshBtnInfoCompl(numCaso);



  }

  _deshBtnInfoCompl(numCaso: number) {

    switch (numCaso) {
      case 1:

        this.flgDeshBtnInfoCompl = true;

        break;

      case 2:

        this.flgDeshBtnInfoCompl = false;

        break;

      default:
        break;
    }

  }

  setGeneralParams(gparams: General) {

    console.log('======this.generalParams2');

    this.contenedorWerb.setGeneralParams(gparams);

  }

  consultarDatosFur(fur: Fur) {

    this.spinner.show();

    let vDenunciante = null;
    let flgLectura = false;

    if (fur.nfurIdestado == NumIdEstadoBorrador) {

      fur.flgRecupBorrador = true;

    } else {

      fur.flgRecupBorrador = false;

    }

    vDenunciante = null;
    flgLectura = !fur.flgRecupBorrador;

    this.flgNewFw = false;

    this.furFw = fur;

    setTimeout(() => {

      this.contenedorWerb.mostrarDatosGen(true);

      this.contenedorWerb.verFormularioWeb(fur, flgLectura);

      this.flgDeshabilitaGuardar = flgLectura;
      this._viewBtnTrx((flgLectura == true ? 2 : 1)); // NO VISUALIZAR LOS BOTONES DE ENVIAR Y GUARDAR BORRAODR

      vDenunciante = fur.denunciante;

      if (vDenunciante == null) {return; }
      if (vDenunciante.persona == null) {return; }

      this.strDscDenunciante = vDenunciante.persona.cpersonaApepaterno + ' ' + vDenunciante.persona.cpersonaApematerno + ', ' + vDenunciante.persona.cpersonaNombres;



      this.spinner.hide();

    }, 10);




  }

  ConsultarFur(fur: Fur) {

    this.furFw = fur;

    this.mFormularioWebC = new MformularioWebC();

    this.mFormularioWebC.datosGeneral = new DatosGeneral();

    this.mFormularioWebC.datosGeneral.estado_formulario = fur.estado.nestadoId.toString();
    this.mFormularioWebC.datosGeneral.fecha_registro = fur.fch_inicio_reg;
    this.mFormularioWebC.datosGeneral.hora_inicio = fur.hora_inicio_reg;
    this.mFormularioWebC.datosGeneral.nro_formulario = fur.cfurCodigo;

    this.datosGeneralC.ConsultarDatosGenerales(this.mFormularioWebC.datosGeneral);

    this.mFormularioWebC.mDenunciaContenedorC = new MdenunciaContenedorC();
    this.mFormularioWebC.mDenunciaContenedorC.mEntidadHechoC = new MentidadHechoC();

    this.mFormularioWebC.mDenunciaContenedorC.mEntidadHechoC.flg_deshabilita = true;
    this.mFormularioWebC.mDenunciaContenedorC.mEntidadHechoC.select_entidades = fur.cfurCodent;
    this.mFormularioWebC.mDenunciaContenedorC.mEntidadHechoC.inputDireccion = fur.cfurDirentidad;
    this.mFormularioWebC.mDenunciaContenedorC.mEntidadHechoC.inputReferencia = fur.cfurDscrefentidad;
    this.mFormularioWebC.mDenunciaContenedorC.mEntidadHechoC.select_departamento = fur.cfurCdepent;
    this.mFormularioWebC.mDenunciaContenedorC.mEntidadHechoC.select_provincia = fur.cfurCprovent;
    this.mFormularioWebC.mDenunciaContenedorC.mEntidadHechoC.select_distrito = fur.cfurCdistent;



    this.denunciaContenedorC.ConsultarDenuncia(this.mFormularioWebC.mDenunciaContenedorC);


  }

  validarTab(valor) {


    this.tabDenunciante = valor;

    if (valor) {

      setTimeout(() => {

        document.getElementById('aTabDenun').click();

      }, 1);

    }

  }

  ActivaPanelMP(flgSolicitaMPB) {

    this.tabProteccion = flgSolicitaMPB;

    if (flgSolicitaMPB) {

      setTimeout(() => {

        document.getElementById('aTabMP').click();

      }, 1);

    }

  }

  guardarBorrador() {

    openModalMensajePrg(this.strDscTitulo, '¿Está seguro que desea Guardar Borrador?', this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        this.flgEnviarDenuncia = false;
        this.flgGuardarBorrador = true;
        this.strDscMensajeSpinner = DscMensajeSpinner2; // "Estamos procesando el guardado en borrador de su denuncia";
        this.flgDeshabilitaGuardar = true;
        this.flgAccionGB = true;
        this.flgDeshabilitarSalir = true;

        this.contenedorWerb.deshabilitarCamposFur();

        this._registrarFur();



      }

    });

  }

  _registrarFur() {

    this.contenedorWerb.setFurFw(this.furFw);

    this.contenedorWerb.setFlgEnviarDenuncia(this.flgEnviarDenuncia);
    this.contenedorWerb.setFlgGuardarBorrador(this.flgGuardarBorrador);

    this.contenedorWerb.Guardar(0, null, null, null);

  }

  guardar() {

    let vflgValido = false;

    openModalMensajePrg(this.strDscTitulo, '¿Está seguro que desea enviar denuncia a OEFA?', this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        vflgValido =  this.contenedorWerb.validarGuardar();

        if (vflgValido) {
          /** SE AGREGAR EL CAPTCHA ANTES DE ENVIAR */
          const valCaptcha = (document.getElementById('textoCaptcha1') as HTMLInputElement).value;
          const data = {deviceId: this.captchaId, textoCaptcha: valCaptcha};
          this.entidadService.validarcaptcha(data).subscribe(idata => {
              if (idata != null) {
                if (idata.success) {
                  // window.localStorage.setItem('token', 'Bearer ' + idata.token);
                  this.flgEnviarDenuncia = true;
                  this.flgGuardarBorrador = false;
                  this.strDscMensajeSpinner = DscMensajeSpinner2;
                  this.flgDeshabilitarSalir = true;

                  this._registrarFur();

                  this.flgDeshabilitaGuardar = true;

                  this.contenedorWerb.deshabilitarCamposFur();

                  openModalMensaje('Atención de Denuncias', 'Registro Conforme', this.dialog);
                  cambiarRouter(this.router, 4);
                } else {
                  openModalMensaje('Atención de Denuncias', 'Ingrese el Captcha correctamente, por favor verifique', this.dialog);
                  return;
                }
              }
            },
            err => {console.error('Observer got an error: ' + err); },
            () => {});




        }


      }



    });

    // var vflgValido =  this.guardarBorrador();


  }

  _enviarInfoCompl() {

    // this.InfoComplementariaWebC.guardar();

    let vflgValido = false;

    openModalMensajePrg(this.strDscTitulo, '¿Está seguro que desea enviar la información complementaria a CGR?', this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        vflgValido =  this.contenedorWerb.validarGuardarInfoCompl();

        if (vflgValido) {

          this.strDscMensajeSpinner = DscMensajeSpinner2;

          this._deshBtnInfoCompl(1);
          this.flgDeshabilitarSalir = true;

          this.contenedorWerb.guardarInfoCompl();

        }


      }



    });

    // var vflgValido =  this.guardarBorrador();


  }



  regresar() {
    this.contenedorWerb._habilitarCamposFur();
    this.flgGuardarDefinitivo = false;
  }

  _guardadoInfoCompl(dataReturn: General) { // RETORNA DESPUES DE GUARDAR

    if (dataReturn.flgCampo1 == false) {

      this._deshBtnInfoCompl(2);

    }
    this.flgDeshabilitarSalir = false;

  }

  // CUANDO SE PROCESE CORRECTAMENTE EL GUARDADO DEL FW
  // _guardadoFw(furFw:Fur){
  _guardadoFw(fur: Fur) {

    // this.furFw = furFw;

    this.flgDeshabilitarSalir = false;

    if (this.flgAccionGB == true) {

      this.flgDeshabilitaGuardar = false;
      this.flgAccionGB = false;



      setTimeout(() => {

        this.spinner.show();

        this.flgViewCW = false;

        this.spinner.hide();

      }, 0);

      setTimeout(() => {

        this.spinner.show();

        this.flgViewCW = true;

        this.spinner.hide();

      }, 0);

      setTimeout(() => {

        //this.consultarDatosFur(fur);

        this.spinner.hide();

      }, 0);





    }

  }
  url: String = `${servicioToken}`;
  urlImagen: any;
  captchaId;
  loadCaptcha() {
    this.captchaId = uuid(null, null);
    this.urlImagen = loadCaptcha01(this.url, this.captchaId);
  }

}
